(function () {
  BookingService.$inject = ["$http", "$q"];
  angular.module('userApp').service('BookingService', BookingService);

  function BookingService($http, $q) {}
})();